import type React from 'react';

// Global CSS targeting HugeRTE's third-party `.tox-*` classes (no Tailwind hook available,
// and we no longer use emotion/theme-ui). Injected via a plain <style> element.
// Colour literals: greyBackground #F2F2F2, black #000000, changeRed #E01A2B, white #FFFFFF,
// neutral-grey600 #707070.
const STYLES = `
body .tox .tox-toolbar,
body .tox:not(.tox-hugerte-inline) .tox-editor-header,
body .tox .tox-toolbar__overflow,
body .tox .tox-toolbar__primary,
body .tox .tox-dialog__header,
body .tox .tox-dialog__body,
body .tox .tox-dialog__footer { background-color: #F2F2F2 !important; }
body .tox .tox-editor-header .tox-tbtn:not(:hover):not(:active):not(.tox-tbtn--enabled) { background-color: transparent !important; }
body .tox .tox-button:not(.tox-button--icon):not(.tox-button--secondary):focus { border-color: #000000; }
body .tox .tox-button:not(.tox-button--icon):not(.tox-button--secondary):hover { filter: brightness(0.8); border-color: #000000; }
body .tox .tox-button:not(.tox-button--icon):not(.tox-button--secondary) {
	background-color: #E01A2B;
	border-color: #E01A2B;
	font-size: 16px;
	line-height: 24px;
	min-height: 44px;
	border-radius: 8px;
	border-width: 2px;
	padding: 8px 22px;
}
body .tox .tox-button--secondary:focus:not(:disabled) {
	background-color: #FFFFFF;
	border-width: 2px;
	border-color: #000000;
	padding: 8px 22px;
}
body .tox .tox-button--secondary:hover:not(:disabled) {
	background-color: #FFFFFF;
	border-width: 2px;
	border-color: #000000;
	padding: 8px 22px;
}
body .tox .tox-button--secondary {
	background-color: #FFFFFF;
	font-size: 16px;
	line-height: 24px;
	min-height: 44px;
	border-radius: 8px;
	border-width: 1px;
	border-color: #707070;
	padding: 9px 23px;
}
body .tox .tox-dialog__body-nav { display: none; }
body .tox-hugerte { border-radius: 5px; border-color: #707070; }
body .tox-notifications-container { display: none; }
body .tox .tox-edit-area::before { border-width: 0 !important; }
`;

export const GlobalStyle: React.FC = () => {
	// eslint-disable-next-line react/no-danger
	return <style dangerouslySetInnerHTML={{ __html: STYLES }} />;
};
